import React, { useEffect, useState } from 'react'
import { Card, CardBody, Col, Row, Badge, Button, Input, Label, Modal, ModalBody } from 'reactstrap';
import Skeleton from "react-loading-skeleton";
import PayAsYouGo from "../../assets/images/pay-as-you-go.png"
import Essentials from "../../assets/images/essential.png"
import Professional from "../../assets/images/professional.png"
import Premium from "../../assets/images/premium.png"
import Enterprise from "../../assets/images/enterprise.png"
import listIcon from "../../assets/images/list-icon.png"
import listIconWhite from "../../assets/images/list-icon-white.png"
import { chooseAnotherCountry, getPhoneNumbers, getPlans, letsTalkPlan } from '../../helper/backend-methods';
import { showToast } from '../../components/Toast';
import Image from '../../components/Image'
import "../../assets/css/--component-billing-pricing.css"
import ReactCountryFlag from "react-country-flag";
import Select from "react-select";
import { compressToEncodedURIComponent } from "lz-string";
import { Link } from 'react-router-dom';
import campaignSuccess from "../../assets/images/campaign-success.png"
import { useAppContext } from '../../context/AppContext';

const plansOld = [
    {
        title: "Essentials",
        price: "$100.00",
        period: "/month",
        description: "500 minutes per month, 0.1$ per excess minute",
        button: "Select Plan",
        mostPopular: false,
        icon: Essentials
    },
    {
        title: "Professional",
        price: "$200.00",
        period: "/month",
        description: "50,000 minutes per month, 0.25$ per excess minute",
        button: "Select Plan",
        mostPopular: true,
        badge: "Most Popular",
        icon: Professional
    },
    {
        title: "Premium",
        price: "$500.00",
        period: "/month",
        description: "50,000 minutes per month, 0.1$ per excess minute",
        button: "Select Plan",
        mostPopular: false,
        icon: Premium
    },
    {
        title: "Enterprise",
        price: "Let's Talk",
        period: "",
        description: "Custom minutes per month, $0.05 per excess minute",
        button: "Get in Touch",
        mostPopular: false,
        icon: Enterprise
    },
];
const PricingPlans = () => {
    const { markTaskDoneTour, activeTour } = useAppContext();
    const [billing, setBilling] = useState("monthly");
    const [plans, setPlans] = useState([]);
    const [phoneNumberPlans, setPhoneNumberPlans] = useState([]);
    const [userSelection, setUserSelection] = useState({ plan: "", planName: "", planPrice: "", overChargePerMin: 0, freeMinutesIncluded: "", phoneNumberAmount: "", phoneNumberCountry: "", selectedNumber: "", phonePriceId: "", outboundEnabled: true, topupAmount: 0, autoRecharge: true })
    const [businessDetails, setBusinessDetails] = useState({ businessName: "", businessOwnerName: "", businessPhone: "", businessAddress: "", businessCountry: null })
    const [phoneNumberList, setPhoneNumberList] = useState([]);
    const [currentTab, setCurrentTab] = useState(1);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [topupAmount, setTopupAmount] = useState("");
    const [topupSelected, setTopupSelected] = useState(null);
    const [loading, setLoading] = useState(false)
    const [summaryModal, setSummaryModal] = useState(false);
    const [phoneModal, setPhoneModal] = useState(false);
    const [phoneSuccessModal, setPhoneSuccessModal] = useState(false);
    const [letsTalkModal, setLetsTalkModal] = useState(false);
    const [errors, setErrors] = useState({ businessName: false, businessOwnerName: false, businessPhone: false, businessAddress: false, businessCountry: false });
    const steps = [
        { id: 1, label: "Choose a Pricing Plan", icon: <i className="ri-money-dollar-circle-line" style={{ color: "#939393" }}></i>, iconActive: <i className="ri-money-dollar-circle-line"></i> },
        { id: 2, label: "Choose a Phone Number", icon: <i className="ri-smartphone-line" style={{ color: "#939393" }}></i>, iconActive: <i className="ri-smartphone-line"></i> },
        { id: 3, label: "Outbound Calling Option", icon: <i className="ri-phone-line" style={{ color: "#939393" }}></i>, iconActive: <i className="ri-phone-line"></i> },
    ];
    const countries = JSON.parse(process.env.REACT_APP_COUNTRIES_JSON || "[]");
    
    const businessCountries = [
        { code: "AR", name: "Argentina" },
        { code: "AU", name: "Australia" },
        { code: "AT", name: "Austria" },
        { code: "BE", name: "Belgium" },
        { code: "BR", name: "Brazil" },
        { code: "BG", name: "Bulgaria" },
        { code: "CO", name: "Colombia" },
        { code: "HR", name: "Croatia" },
        { code: "CZ", name: "Czechia" },
        { code: "DK", name: "Denmark" },
        { code: "EC", name: "Ecuador" },
        { code: "SV", name: "El Salvador" },
        { code: "EE", name: "Estonia" },
        { code: "FI", name: "Finland" },
        { code: "DE", name: "Germany" },
        { code: "HK", name: "Hong Kong" },
        { code: "HU", name: "Hungary" },
        { code: "IT", name: "Italy" },
        { code: "JP", name: "Japan" },
        { code: "KE", name: "Kenya" },
        { code: "LT", name: "Lithuania" },
        { code: "MY", name: "Malaysia" },
        { code: "MX", name: "Mexico" },
        { code: "NL", name: "Netherlands" },
        { code: "NZ", name: "New Zealand" },
        { code: "PA", name: "Panama" },
        { code: "PH", name: "Philippines" },
        { code: "PL", name: "Poland" },
        { code: "PT", name: "Portugal" },
        { code: "RO", name: "Romania" },
        { code: "SK", name: "Slovakia" },
        { code: "SI", name: "Slovenia" },
        { code: "ZA", name: "South Africa" },
        { code: "SE", name: "Sweden" },
        { code: "CH", name: "Switzerland" },
        { code: "TH", name: "Thailand" },
        { code: "TN", name: "Tunisia" }
    ];

    const countryOptions = countries.map((c) => ({
        value: c.code,
        label: (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <ReactCountryFlag countryCode={c.code} svg style={{ fontSize: "1.5em" }} />
                <span>{c.name}</span>
            </div>
        ),
    }));
    const BusinessCountryOptions = businessCountries.map((c) => ({
        value: c.code,
        label: (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <ReactCountryFlag countryCode={c.code} svg style={{ fontSize: "1.5em" }} />
                <span>{c.name}</span>
            </div>
        ),
    }));

    useEffect(() => {
        getPlansHandler()
    }, [])

    const getPlansHandler = () => {
        setLoading(true)
        // setAgents([])
        getPlans().then((data) => {
            if (data.data) {
                planTransform(data.data)
                setPlans(planTransform(data.data))
            }
            else {
                showToast("error", "Request Failed", data.message)
            }
            setLoading(false)
        }).catch((err) => {
            showToast("error", "Request Failed", err.message)
            setLoading(false)
        })
    }

    const planTransform = (plans) => {

        const nonMetaDataPlans = plans.filter(plan =>
            !plan.product.metadata ||
            Object.keys(plan.product.metadata).length === 0 ||
            plan.product.metadata.ai_package !== "true"
        );
        setPhoneNumberPlans(nonMetaDataPlans);

        const filteredPlans = plans.filter(plan => {
            const metadata = plan.product?.metadata;
            return metadata && typeof metadata === 'object' && metadata.ai_package === "true";
        });

        const transformedPlans = filteredPlans.map(plan => {
            const basePlan = {
                id: plan.id,
                title: plan.product.name,
                price: `$${(plan.unit_amount / 100).toFixed(2)}`,
                period: `/month`,
                overChargePerMin: plan.product?.metadata?.overChargePerMin,
                description: [],
                button: "Select Plan",
                mostPopular: false,
                icon: null,
                originalData: plan // keep original data if needed
            };

            switch (plan.product.name) {
                case "Pay As You Go":
                    return {
                        ...basePlan,
                        icon: PayAsYouGo,
                        description: [
                            "No monthly base fee",
                            "Pay only for the AI minutes you use",
                            `$${(plan.product.metadata.overChargePerMin / 100).toFixed(2)} per minute AI Agent Fee`,
                            "Unlimited number of AI Agents",
                            "Unlimited number of calls",
                            "Unlimited number of Campaigns",
                            "Phone number in US, UK or Canada",
                            "No long-term commitment, cancel anytime"
                        ]
                    };
                case "Essentials":
                    return {
                        ...basePlan,
                        icon: Essentials,
                        description: [
                            `$${(plan.unit_amount / 100).toFixed(2)} per Month`,
                            "475 AI Minutes",
                            "Unlimited number of AI Agents",
                            "Unlimited number of calls",
                            "Unlimited Number of Campaigns",
                            "Phone number in US, UK or Canada",
                            "Call Summaries",
                            `$${(plan.product.metadata.overChargePerMin / 100).toFixed(2)} per minute AI Agent Fee for Overages`
                        ]
                    };
                case "Professional":
                    return {
                        ...basePlan,
                        mostPopular: true,
                        badge: "Most Popular",
                        icon: Professional,
                        description: [
                            `$${(plan.unit_amount / 100).toFixed(2)} per Month`,
                            "Everything in Essentials with",
                            "1,350 AI Minutes",
                            `$${(plan.product.metadata.overChargePerMin / 100).toFixed(2)} per minute AI Agent Fee for Overages`
                        ]
                    };
                case "Premium":
                    return {
                        ...basePlan,
                        icon: Premium,
                        description: [
                            `$${(plan.unit_amount / 100).toFixed(2)} per Month`,
                            "Everything in Essentials with",
                            "3,095 AI Minutes",
                            `$${(plan.product.metadata.overChargePerMin / 100).toFixed(2)} per minute AI Agent Fee for Overages`
                        ]
                    };
                default:
                    return basePlan;
            }
        });

        // Add Enterprise plan
        const finalPlans = [
            ...transformedPlans,
            {
                id: "enterprise",
                title: "Enterprise",
                price: "Let's Talk",
                period: "",
                description: [
                    "Everything in Premium",
                    "Discounted rates based on commitment",
                    "Professional AI Voice Clones",
                    "Custom contract with your terms & conditions",
                    "Ability to use your own number",
                    "On Prem Implementations upon request"
                ],
                button: "Get in Touch",
                mostPopular: false,
                icon: Enterprise
            }
        ];

        return finalPlans;
    }
    const nextStep = (step, validate = true) => {
        if (!validate) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setCurrentTab(step);
        }
        if (step === 2) {
            const isInPromptTour = activeTour && activeTour.taskId === 4;

            if (isInPromptTour) {
                const driverInstance = document.querySelector('.driver-popover');
                if (driverInstance) {
                    const closeBtn = driverInstance.querySelector('.driver-popover-close-btn');
                    if (closeBtn) {
                        closeBtn.click();
                    }
                }
                setTimeout(() => {
                    markTaskDoneTour(4);
                }, 100);
            } else {
                markTaskDoneTour(4, false);
                setCurrentTab(2);
            }

        }
        if (step === 3) {
            let flag = false;
            let error = { selectedCountry: "", selectedNumber: "" };
            if (!selectedCountry) {
                flag = true;
                error.selectedCountry = "Please select a country";
            }
            if (selectedCountry && !userSelection.selectedNumber) {
                flag = true;
                error.selectedNumber = "Please select a phone number";
            }
            setErrors(error);
            if (!flag) {
                setCurrentTab(3)
            }
        }
        if (step === 4) {
            let flag = false;
            let error = { topupAmount: "" };
            if (userSelection.outboundEnabled && !userSelection.topupAmount) {
                flag = true;
                error.topupAmount = "Please provide a topup amount";
            }
            setErrors(error);
            if (!flag) {
                setSummaryModal(true)
            }
        }
    }

    const topupOptions = [20, 50, 100, 250, 300];

    // Handle button selection
    const handleSelect = (value) => {
        setTopupAmount(value);
        setUserSelection((prev) => { return { ...prev, topupAmount: value } })
        setTopupSelected(value);
    };

    // Handle custom input
    const handleChange = (e) => {
        const value = e.target.value.replace(/\D/g, "").slice(0, 4); // allow only numbers
        setTopupAmount(value);
        setUserSelection((prev) => { return { ...prev, topupAmount: value } })
        setTopupSelected(null); // deselect buttons
    };

    const countrySelectHandler = (country) => {
        setLoading(true)
        const countryMatchingPlan = phoneNumberPlans.find(plan =>
            plan.lookup_key === country.value
        );
        if (countryMatchingPlan) {
            setUserSelection((prev) => { return { ...prev, phonePriceId: countryMatchingPlan.id, phoneNumberCountry: country.value } })
            getPhoneNumbers({ country: country.value }).then((data) => {
                if (data.data) {
                    setSelectedCountry(country)
                    setUserSelection((prev) => { return { ...prev, phoneNumberAmount: (countryMatchingPlan.unit_amount / 100).toFixed(2) } })
                    setPhoneNumberList(data.data.list)
                }
                else {
                    showToast("error", "Request Failed", data.message)
                }
                setLoading(false)
            }).catch((err) => {
                showToast("error", "Request Failed", err.message)
                setLoading(false)
            })
        }
        else {
            showToast("error", "Request Failed", "No country found.")
            setSelectedCountry(null)
            setLoading(false)
        }
    }
    const businessCountrySelectHandler = (country) => {
        setBusinessDetails((prev) => { return { ...prev, businessCountry: country } })
    }
    const calculateTotal = () => {
        const planPrice = Number(userSelection.planPrice?.replace('$', '') || 0);
        const phoneAmount = Number(userSelection.phoneNumberAmount || 0);
        const topupAmount = userSelection.outboundEnabled && userSelection.topupAmount && userSelection.autoRecharge
            ? Number(userSelection.topupAmount || 0)
            : 0;

        const totalAmount = planPrice + phoneAmount + topupAmount;
        return totalAmount;
    };

    const requestAnotherNumberHandler = () => {
        let flag = false;
        let error = { businessName: false, businessOwnerName: false, businessPhone: false, businessAddress: false, businessCountry: false };
        if (!businessDetails.businessName || businessDetails.businessName.replace(/\s/g, '').length < 1) {
            flag = true;
            error.businessName = "Please provide valid business name";
        }
        if (!businessDetails.businessOwnerName || businessDetails.businessOwnerName.replace(/\s/g, '').length < 1) {
            flag = true;
            error.businessOwnerName = "Please provide valid owner name";
        }
        if (!businessDetails.businessAddress || businessDetails.businessAddress.replace(/\s/g, '').length < 1) {
            flag = true;
            error.businessAddress = "Please provide valid address";
        }
        if (!businessDetails.businessPhone || businessDetails.businessPhone.replace(/\s/g, '').length < 1) {
            flag = true;
            error.businessPhone = "Please provide valid phone number";
        }
        if (!businessDetails.businessCountry.value || businessDetails.businessCountry.value.replace(/\s/g, '').length < 1) {
            flag = true;
            error.businessCountry = "Please choose a country";
        }
        setErrors(error)
        if (!flag) {
            setLoading(true);
            const formData = {
                "businessName": businessDetails.businessName,
                "businessOwnerName": businessDetails.businessOwnerName,
                "businessPhoneNumber": businessDetails.businessPhone,
                "businessAddress": businessDetails.businessAddress,
                "requestedCountry": businessDetails.businessCountry.value
            }
            chooseAnotherCountry(formData).then((data) => {
                setLoading(false);
                setPhoneSuccessModal(true)
            }).catch((e) => {
                showToast("error", "Phone Request Failed", "Your new phone request could not be processed.")
                setLoading(false);
            })
        }
    }

    const letsTalkHandler = () => {
        setLoading(true)
        letsTalkPlan().then((data) => {
            setLoading(false);
            setLetsTalkModal(true)
        }).catch((e) => {
            showToast("error", "Request Failed", "Your request could not be processed.")
            setLoading(false);
        })
    }
    return (
        <div className="content-page">
            <div className="content">
                <div className="container-fluid">
                    <div className="py-3 row">
                        <div className="col-12">
                            <Row className="my-2 align-items-center">
                                <Col md={12}>
                                    <h4>Pricing Plans</h4>
                                    <p className='text-muted fs-12'>Please select a Pricing Plan</p>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <Card>
                        <CardBody>
                            <Row>
                                <Col md={12}>
                                    <div className="d-flex justify-content-center mb-5">
                                        {steps.map((step, index) => (
                                            <React.Fragment key={step.id}>
                                                <div className="d-flex flex-column align-items-center justify-content-center text-center">
                                                    <div
                                                        className={`d-flex justify-content-center align-items-center text-white fs-16 steps-card`}
                                                        style={{ border: index === currentTab - 1 ? "none" : "1px solid #e6e6e6", background: index === currentTab - 1 ? "var(--wr-gradient-brand)" : "#fff" }}
                                                    >
                                                        {index === currentTab - 1 ? step.iconActive : step.icon}
                                                    </div>
                                                    <div className="">
                                                        <h6 className={`mb-0 mt-2 ${index === currentTab - 1 ? "text-black" : "text-muted"}`}>{step.label}</h6>
                                                        {/* <small className={`${index === currentTab - 1 ? "text-black" : "text-muted"}`}>{step.description}</small> */}
                                                    </div>
                                                </div>
                                                {index < 2 ? <span className="steps-separator"></span> : null}
                                            </React.Fragment>
                                        ))}
                                    </div>
                                </Col>
                            </Row>

                            {
                                currentTab === 1 ?
                                    <>
                                        <h3 className="mt-2 mb-4 fs-26 text-dark">Select a Pricing Plan</h3>
                                        {/* Billing toggle */}
                                        {/* <div className="d-flex justify-content-start mb-4">
                                            <div className="bg-light rounded-pill p-1 d-inline-flex">
                                                <Button
                                                    color={`${billing === 'monthly' ? 'primary' : 'link'}`}
                                                    size="lg"
                                                    className={`rounded-pill px-5 fs-16 fw-400 ${billing === 'monthly' ? 'linear-gradient-btn' : 'text-muted'}`}
                                                    onClick={() => setBilling('monthly')}
                                                >
                                                    Monthly
                                                </Button>
                                                <Button
                                                    color={`${billing === 'annual' ? 'primary' : 'link'}`}
                                                    size="lg"
                                                    className={`rounded-pill px-5 fs-16 fw-400 ${billing === 'annual' ? 'linear-gradient-btn' : 'text-muted'}`}
                                                    onClick={() => setBilling('annual')}
                                                >
                                                    Annual
                                                </Button>
                                            </div>
                                        </div> */}
                                        {/* Plan Cards */}
                                        <Row className="g-4 justify-content-center" id='plan-card'>
                                            {
                                                loading ?
                                                    <>
                                                        {/* <Row className='mt-4'> */}
                                                        <Col md={6} lg={4}><Skeleton height={300} /></Col>
                                                        <Col md={6} lg={4}><Skeleton height={300} /></Col>
                                                        <Col md={6} lg={4}><Skeleton height={300} /></Col>
                                                        <Col md={6} lg={4}><Skeleton height={300} /></Col>
                                                        <Col md={6} lg={4}><Skeleton height={300} /></Col>
                                                        {/* </Row> */}
                                                    </>
                                                    :
                                                    plans.length ?
                                                        plans.map((plan, idx) => (
                                                            <Col key={idx} md={6} lg={4}>
                                                                <Card
                                                                    className={`shadow-sm border-0 h-100 rounded-3 ${plan.mostPopular ? 'text-white' : ''}`}
                                                                    style={
                                                                        plan.mostPopular
                                                                            ? {
                                                                                background: 'var(--wr-gradient-brand)',
                                                                            }
                                                                            : {}
                                                                    }
                                                                >
                                                                    <CardBody className='px-3'>
                                                                        <div className='d-flex flex-column justify-content-between h-100'>
                                                                            <div>
                                                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                                                    <Image src={plan.icon} alt="Icon" className='rounded-circle me-2' height='43px' width='43px' objectFit='cover' />
                                                                                    {plan.badge && (
                                                                                        <Badge color="light" className="text-primary p-2 fs-12 rounded-3"><span className="text-gradient">{plan.badge}</span></Badge>
                                                                                    )}
                                                                                </div>
                                                                                <h2 className={`fw-500 fs-24 ${plan.mostPopular ? 'text-white' : ''}`}>{plan.title}</h2>
                                                                                <h4 className="fw-600">
                                                                                    <span className={`fs-34 fw-600 ${plan.mostPopular ? 'text-white' : 'text-gradient'}`}>{plan.price}</span>
                                                                                    <small className={`${plan.mostPopular ? 'text-white' : 'text-dark'}`}>{plan.period}</small>
                                                                                </h4>
                                                                                <ul className={`mt-3 fs-16 feature-list ${plan.mostPopular ? 'text-white' : 'text-dark'}`}>
                                                                                    {
                                                                                        plan.description.map((desc, index) => {
                                                                                            return (
                                                                                                <li style={{
                                                                                                    background: plan.mostPopular
                                                                                                        ? `url(${listIconWhite}) no-repeat left center`
                                                                                                        : `url(${listIcon}) no-repeat left center`,
                                                                                                    backgroundSize: '20px',
                                                                                                    paddingLeft: '30px',
                                                                                                    marginBottom: '8px',
                                                                                                    listStyle: 'none'
                                                                                                }}>{desc}</li>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </ul>
                                                                            </div>
                                                                            <Button
                                                                                color="primary"
                                                                                className="w-100 mt-3 py-2 rounded-3 border-0"
                                                                                onClick={() => { if (plan.id !== "enterprise") { setUserSelection((prev) => { return { ...prev, plan: plan.id, planName: plan.title, planPrice: plan.price, overChargePerMin: plan.overChargePerMin, freeMinutesIncluded: plan.originalData.product.metadata.freeMinutesIncluded } }); nextStep(2) } else { letsTalkHandler() } }}
                                                                                style={
                                                                                    plan.mostPopular
                                                                                        ? { backgroundColor: '#fff', color: '#000' }
                                                                                        : { background: 'var(--wr-gradient-brand)' }
                                                                                }
                                                                            >
                                                                                {plan.button}
                                                                            </Button>
                                                                        </div>
                                                                    </CardBody>
                                                                </Card>
                                                            </Col>
                                                        ))
                                                        :
                                                        <>
                                                            <div className="p-3 rounded-3 mb-4 d-flex align-items-center justify-content-between trial-container">
                                                                <p className='m-0 text-danger'><i className="ri-information-line fs-16"></i> Sorry, No plans found at the moment.</p>
                                                            </div>
                                                        </>
                                            }
                                        </Row>
                                    </>
                                    :
                                    currentTab === 2 ?
                                        <>
                                            <div id='chooseNumber'>
                                                <h3 className="mt-2 mb-4 fs-26 text-dark">Phone Number</h3>
                                                <div>
                                                    <label className="fw-bold text-dark">Choose a Phone Number</label>
                                                    <Select
                                                        options={countryOptions}
                                                        value={selectedCountry}
                                                        onChange={countrySelectHandler}
                                                        placeholder="Select Country"
                                                        className="mt-2"
                                                        styles={{
                                                            control: (base) => ({
                                                                ...base,
                                                                backgroundColor: "#f4f4f4",
                                                                border: "none",
                                                                padding: "6px",
                                                                borderRadius: "12px",
                                                                boxShadow: "none",
                                                            }),
                                                        }}
                                                    />
                                                    {errors.selectedCountry && <p className="invalid-feedback">{errors.selectedCountry}</p>}
                                                    {/* <p className='text-gradient mt-3 cursor-pointer fs-16 d-inline-block' onClick={() => { setPhoneModal(true) }}>Choose another country</p> */}
                                                    {
                                                        selectedCountry && !loading && phoneNumberList.length ?
                                                            <>
                                                                {/* <Label htmlFor="phoneList" className="text-left text-black font-bold"> Choose Phone Number </Label> */}
                                                                <Input id="phoneList" className='custom-select rounded border-0 py-2 mt-3' type="select" value={userSelection.selectedNumber} onChange={(e) => { setUserSelection((prev) => { return { ...prev, selectedNumber: e.target.value } }); }} >
                                                                    <option value="">Choose Phone Number</option>
                                                                    {phoneNumberList.map((item) => (
                                                                        <option key={item.phoneNumber} value={item.phoneNumber} className='text-capitalize'>
                                                                            {item.phoneNumber} ({item.isoCountry}, {item.locality})
                                                                        </option>
                                                                    ))}
                                                                </Input>

                                                                {errors.selectedNumber && <p className="invalid-feedback">{errors.selectedNumber}</p>}
                                                                <div className='mt-3'>
                                                                    <p className='mb-2 text-dark fs-16'>Monthly cost for this country:</p>
                                                                    <div className='d-flex gap-2 align-items-center'><h4 className="text-gradient fs-40">${userSelection.phoneNumberAmount}</h4><span className="text-dark fs-16">/month</span></div>
                                                                </div>
                                                            </> :
                                                            loading ?
                                                                <Skeleton height={45} className='mt-3 rounded-3' />
                                                                :
                                                                <></>
                                                    }
                                                </div>
                                                <Row className='mt-4'>
                                                    <Col md={12} className='text-right'>
                                                        <button disabled={loading} onClick={() => { setCurrentTab(1) }} className="px-4 py-2 rounded me-2 outline-gradient-btn"> <span>Back</span> </button>
                                                        {/* <Button color='outline-primary' onClick={() => { setCurrentTab(1) }} className="px-4 py-2 rounded me-2 outline-gradient-btn"><span>Back</span></Button> */}
                                                        <Button disabled={loading} onClick={() => { nextStep(3) }} className="px-4 py-2 rounded linear-gradient-btn mb-1">{loading ? (<> <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Please Wait </>) : "Next"}</Button>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </>
                                        :
                                        <>
                                            <div id='topupSetting'>
                                                <h3 className="mt-2 mb-4 fs-26 text-dark">Outbound Calling</h3>

                                                <div className='mb-2'>
                                                    <p className='text-dark'>Do you want outbound calling?</p>
                                                    <div className="custom-radio-group mt-2">
                                                        <div className="custom-radio-option">
                                                            <Input
                                                                type="radio"
                                                                name="outboundCalling"
                                                                id="outboundCallingNo"
                                                                checked={!userSelection.outboundEnabled}
                                                                onChange={() => setUserSelection((prev) => { return { ...prev, outboundEnabled: false } })}
                                                                className="custom-radio-input"
                                                            />
                                                            <Label for="outboundCallingNo" className="custom-radio-label">
                                                                No
                                                            </Label>
                                                        </div>
                                                        <div className="custom-radio-option">
                                                            <Input
                                                                type="radio"
                                                                name="outboundCalling"
                                                                id="outboundCallingYes"
                                                                checked={userSelection.outboundEnabled}
                                                                onChange={() => setUserSelection((prev) => { return { ...prev, outboundEnabled: true } })}
                                                                className="custom-radio-input"
                                                            />
                                                            <Label for="outboundCallingYes" className="custom-radio-label">
                                                                Yes
                                                            </Label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='info-box'>
                                                    <p className='m-0 text-dark'><i className="ri-information-line fs-16"></i> Outbound calls require a wallet. Each call costs between <span className='text-gradient'>$0.028 - $0.58</span> per minute, depending on the destination country. These costs will be deducted from your wallet.</p>
                                                </div>
                                                {
                                                    userSelection.outboundEnabled ?
                                                        <>
                                                            <p className='text-dark mt-4'>Select Monthly Wallet Top-Up Amount</p>
                                                            <div className="d-flex gap-2 mb-3 mt-2 flex-wrap">
                                                                {topupOptions.map((value) => (
                                                                    <Button
                                                                        key={value}
                                                                        className='fw-400'
                                                                        onClick={() => handleSelect(value)}
                                                                        style={{
                                                                            background: topupSelected === value
                                                                                ? "var(--wr-gradient-brand)"
                                                                                : "#f8f9fa",
                                                                            color: topupSelected === value ? "#fff" : "#000",
                                                                            border: "none",
                                                                            padding: "20px 10px",
                                                                            width: "100%",
                                                                            maxWidth: "90px",
                                                                            transition: "all 0.3s ease",
                                                                        }}
                                                                    >
                                                                        ${value}
                                                                    </Button>
                                                                ))}
                                                            </div>
                                                            <div className="d-flex align-items-center mb-2 w-30">
                                                                <hr className="flex-grow-1" />
                                                                <span className="mx-2 text-muted">Or enter custom amount</span>
                                                                <hr className="flex-grow-1" />
                                                            </div>

                                                            <Input type="text" className='custom-input py-2' placeholder="Enter Amount" value={userSelection.topupAmount} onChange={handleChange} />
                                                            {errors.topupAmount && <p className="invalid-feedback">{errors.topupAmount}</p>}

                                                            <div className='mb-2'>
                                                                <p className='text-dark mt-4'>Auto top-up when balance runs out?</p>
                                                                <div className="custom-radio-group mt-2">
                                                                    <div className="custom-radio-option">
                                                                        <Input
                                                                            type="radio"
                                                                            name="autoRecharge"
                                                                            id="autoRechargeNo"
                                                                            checked={!userSelection.autoRecharge}
                                                                            onChange={() => setUserSelection((prev) => { return { ...prev, autoRecharge: false } })}
                                                                            className="custom-radio-input"
                                                                        />
                                                                        <Label for="autoRechargeNo" className="custom-radio-label">
                                                                            No
                                                                        </Label>
                                                                    </div>
                                                                    <div className="custom-radio-option">
                                                                        <Input
                                                                            type="radio"
                                                                            name="autoRecharge"
                                                                            id="autoRechargeYes"
                                                                            checked={userSelection.autoRecharge}
                                                                            onChange={() => setUserSelection((prev) => { return { ...prev, autoRecharge: true } })}
                                                                            className="custom-radio-input"
                                                                        />
                                                                        <Label for="autoRechargeYes" className="custom-radio-label">
                                                                            Yes
                                                                        </Label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='info-box'>
                                                                <p className='m-0 text-dark'><i className="ri-information-line fs-16"></i> You can change top-up settings anytime in Billing.</p>
                                                            </div>
                                                        </>
                                                        : <></>
                                                }
                                                <Row className='mt-4'>
                                                    <Col md={12} className='text-right'>
                                                        <button disabled={loading} onClick={() => { setCurrentTab(2) }} className="px-4 py-2 rounded me-2 outline-gradient-btn"> <span>Back</span> </button>
                                                        {/* <Button color='outline-primary' onClick={() => { setCurrentTab(1) }} className="px-4 py-2 rounded me-2 outline-gradient-btn"><span>Back</span></Button> */}
                                                        <Button disabled={loading} onClick={() => { nextStep(4) }} className="px-4 py-2 rounded linear-gradient-btn mb-1">Next</Button>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </>
                            }
                        </CardBody>
                    </Card>
                    <Modal isOpen={summaryModal} toggle={() => { setSummaryModal(false) }} centered={true} size='md'>
                        <ModalBody id='checkoutSummary'>
                            <Row>
                                <Col md={12} className=''>
                                    <div className="text-center">
                                        <h3 className="mt-2 mb-4 fs-26 text-dark">Price Summary</h3>
                                    </div>
                                    <div className='d-flex justify-content-between mb-3'>
                                        <p className='text-muted m-0 fs-18'>{userSelection.planName}</p>
                                        <p className='text-dark m-0 fs-18'>{userSelection.planPrice}/month</p>
                                    </div>
                                    <div className='d-flex justify-content-between mb-3'>
                                        <p className='text-muted m-0 fs-18'>Phone Number Cost</p>
                                        <p className='text-dark m-0 fs-18'>${userSelection.phoneNumberAmount}/month</p>
                                    </div>
                                    {
                                        userSelection.outboundEnabled && userSelection.topupAmount && userSelection.autoRecharge ?
                                            <>
                                                <div className='d-flex justify-content-between mb-3'>
                                                    <p className='text-muted m-0 fs-18'>Wallet Top-Up</p>
                                                    <p className='text-dark m-0 fs-18'>${topupAmount}/month</p>
                                                </div>
                                            </> : null
                                    }
                                </Col>
                            </Row>
                            <Row className="text-center mt-3 mb-2 summary-footer">
                                <Col md={12}>
                                    <div className='d-flex justify-content-between mb-3'>
                                        <p className='text-dark m-0 fs-18'>Total</p>
                                        <p className='text-dark m-0 fs-18'>${calculateTotal().toFixed(2)}/month</p>
                                    </div>
                                </Col>
                                <Col md={12}>
                                    {
                                        userSelection.outboundEnabled && userSelection.topupAmount && !userSelection.autoRecharge ?
                                            <>
                                                <div className='d-flex justify-content-between mb-3'>
                                                    <p className='text-muted m-0 fs-18'>Wallet Top-Up</p>
                                                    <p className='text-dark m-0 fs-18'>${topupAmount} (One Time)</p>
                                                </div>
                                            </> : null
                                    }
                                </Col>
                                <Col>
                                    <button disabled={loading} onClick={() => { setSummaryModal(false) }} className="px-2 py-2 rounded outline-gradient-btn w-100" >
                                        <span>No, Go Back</span>
                                    </button>
                                </Col>
                                <Col>
                                    <Link to={"/checkout?data=" + compressToEncodedURIComponent(JSON.stringify(userSelection))} className="font-normal py-2 px-3 rounded-2 fs-14 text-decoration-none text-white linear-gradient-btn w-100" >Yes, Continue to Payment</Link>
                                </Col>
                            </Row>
                        </ModalBody>
                    </Modal>
                    <Modal isOpen={phoneModal} toggle={() => { setPhoneModal(false) }} centered={true} size='md'>
                        <ModalBody>
                            <Row>
                                <Col md={12} className=''>
                                    <div className="text-center">
                                        <h3 className="mt-2 mb-4 fs-26 text-dark">Provide Business Details</h3>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12} className='mb-3'>
                                    <Label htmlFor="businessCountry" className="text-left text-black font-bold"> Choose Country </Label>
                                    <Select
                                        id='businessCountry'
                                        options={BusinessCountryOptions}
                                        value={businessDetails.businessCountry}
                                        onChange={businessCountrySelectHandler}
                                        placeholder="Select Country"
                                        className="mt-2"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                backgroundColor: "#f4f4f4",
                                                border: "none",
                                                padding: "6px",
                                                borderRadius: "12px",
                                                boxShadow: "none",
                                            }),
                                        }}
                                    />
                                    {errors.businessCountry && <p className="invalid-feedback">{errors.businessCountry}</p>}
                                </Col>
                                <Col md={12} className='mb-3'>
                                    <Label htmlFor="businessName" className="text-left text-black font-bold"> Business Name </Label>
                                    <input id="businessName" className='custom-input form-control rounded border-0 py-2' type="text" value={businessDetails.businessName} onChange={(e) => { setBusinessDetails((prev) => { return { ...prev, businessName: e.target.value } }); }} />
                                    {errors.businessName && <p className="invalid-feedback">{errors.businessName}</p>}
                                </Col>
                                <Col md={12} className='mb-3'>
                                    <Label htmlFor="businessOwnerName" className="text-left text-black font-bold"> Business Owner Name </Label>
                                    <input id="businessOwnerName" className='custom-input form-control rounded border-0 py-2' type="text" value={businessDetails.businessOwnerName} onChange={(e) => { setBusinessDetails((prev) => { return { ...prev, businessOwnerName: e.target.value } }); }} />
                                    {errors.businessOwnerName && <p className="invalid-feedback">{errors.businessOwnerName}</p>}
                                </Col>
                                <Col md={12} className='mb-3'>
                                    <Label htmlFor="businessPhone" className="text-left text-black font-bold"> Business Phone Number </Label>
                                    <input id="businessPhone" className='custom-input form-control rounded border-0 py-2' type="text" value={businessDetails.businessPhone} onChange={(e) => { setBusinessDetails((prev) => { return { ...prev, businessPhone: e.target.value } }); }} />
                                    {errors.businessPhone && <p className="invalid-feedback">{errors.businessPhone}</p>}
                                </Col>
                                <Col md={12} className='mb-4'>
                                    <Label htmlFor="businessDetails" className="text-left text-black font-bold"> Business Address </Label>
                                    <textarea id="businessDetails" value={businessDetails.businessAddress} onChange={(e) => { setBusinessDetails((prev) => { return { ...prev, businessAddress: e.target.value } }); }} className='fs-16 rounded-3 p-2 custom-textarea h-100' ></textarea>
                                    {errors.businessAddress && <p className="invalid-feedback">{errors.businessAddress}</p>}
                                </Col>
                            </Row>
                            <Row className="text-center mt-5">
                                <Col>
                                    <button disabled={loading} onClick={() => { setPhoneModal(false) }} className="px-2 py-2 rounded outline-gradient-btn w-100" >
                                        <span>No, Go Back</span>
                                    </button>
                                </Col>
                                <Col>
                                    <Button className="font-normal py-2 px-3 rounded-2 fs-14 text-decoration-none text-white linear-gradient-btn w-100" onClick={requestAnotherNumberHandler}>Submit</Button>
                                </Col>
                            </Row>
                        </ModalBody>
                    </Modal>
                    <Modal isOpen={phoneSuccessModal} toggle={() => { setPhoneSuccessModal(false) }} centered={true} size='md' backdrop="static" keyboard={false}>
                        <ModalBody>
                            <Row>
                                <Col md={12} className='text-center'>
                                    <Image src={campaignSuccess} alt="Event" className='rounded-circle me-2' height='200px' width='200px' objectFit='cover' />
                                    <h2>Request Sent Successfully</h2>
                                    <p>Thank you for submitting your details, our team will get back to you shortly!</p>
                                </Col>
                            </Row>
                            <Row className="text-center mt-3">
                                <Col>
                                    <Link to={"/dashboard"} className="font-normal py-2 px-4 rounded fs-16 text-decoration-none text-white linear-gradient-btn">Back to Dashboard</Link>
                                </Col>
                            </Row>
                        </ModalBody>
                    </Modal>
                    <Modal isOpen={letsTalkModal} toggle={() => { setLetsTalkModal(false) }} centered={true} size='md' backdrop="static" keyboard={false}>
                        <ModalBody>
                            <Row>
                                <Col md={12} className='text-center'>
                                    <Image src={campaignSuccess} alt="Event" className='rounded-circle me-2' height='200px' width='200px' objectFit='cover' />
                                    <h2>Request Sent Successfully</h2>
                                    <p>Thank you for choosing enterprise plan, our team will get back to you shortly!</p>
                                </Col>
                            </Row>
                            <Row className="text-center mt-3">
                                <Col>
                                    <Link to={"/dashboard"} className="font-normal py-2 px-4 rounded fs-16 text-decoration-none text-white linear-gradient-btn">Back to Dashboard</Link>
                                </Col>
                            </Row>
                        </ModalBody>
                    </Modal>
                </div>
            </div>
        </div>
    )
}

export default PricingPlans
